var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDll = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m489.715 167.004v284.952c0 26.534-21.51 48.044-48.044 48.044h-296.28c-26.534 0-48.044-21.51-48.044-48.044v-391.912c0-26.534 21.51-48.044 48.044-48.044h198.441z",
    fill: "#dbc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.714 167.004h-113.853c-17.689 0-32.029-14.34-32.029-32.029v-122.974z",
    fill: "#ac80dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.888 427.607h-371.403c-5.081 0-9.2-4.119-9.2-9.2v-168.324c0-5.081 4.119-9.2 9.2-9.2h371.403c5.081 0 9.2 4.119 9.2 9.2v168.324c0 5.081-4.119 9.2-9.2 9.2z",
    fill: "#ac80dd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m127.169 382.919c-1.877 0-3.409-.438-4.567-1.314-1.189-.907-1.752-2.002-1.752-3.253v-89.175c0-1.282.563-2.346 1.752-3.222 1.157-.907 2.69-1.376 4.567-1.376h23.803c5.661 0 10.791 1.001 15.42 2.971 4.598 1.971 8.226 5.161 10.885 9.54 2.659 4.41 3.972 10.259 3.972 17.516v38.348c0 7.257-1.314 13.074-3.972 17.453-2.659 4.41-6.287 7.601-10.885 9.571-4.629 1.971-9.759 2.94-15.42 2.94h-23.803zm7.945-12.636h15.858c5.036 0 8.946-1.408 11.792-4.254 2.815-2.815 4.223-7.194 4.223-13.074v-38.348c0-5.943-1.408-10.322-4.223-13.137-2.846-2.815-6.756-4.223-11.792-4.223h-15.858z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.239 382.919c-1.533 0-2.971-.375-4.316-1.189-1.345-.813-2.002-1.971-2.002-3.503v-89.05c0-1.626.751-2.784 2.221-3.503s3.097-1.095 4.911-1.095c1.783 0 3.409.375 4.911 1.095 1.47.719 2.221 1.877 2.221 3.503v81.105h34.969c1.439 0 2.502.657 3.222 1.939.719 1.314 1.095 2.784 1.095 4.379 0 1.533-.375 2.971-1.095 4.316s-1.783 2.002-3.222 2.002h-42.915z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.141 382.919c-1.533 0-2.971-.375-4.316-1.189-1.345-.813-2.002-1.971-2.002-3.503v-89.05c0-1.626.751-2.784 2.221-3.503s3.097-1.095 4.911-1.095c1.783 0 3.409.375 4.911 1.095 1.47.719 2.221 1.877 2.221 3.503v81.105h34.969c1.439 0 2.502.657 3.222 1.939.719 1.314 1.095 2.784 1.095 4.379 0 1.533-.375 2.971-1.095 4.316-.719 1.345-1.783 2.002-3.222 2.002h-42.915z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDll);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dll.84e372bee23074f725666c62327177f4.svg";